export const packingMockData = {
  packing_rate: {
    current: 38,
    trendData: [36, 37, 38, 39, 38, 38, 38],
    trend: 'up',
    status: 'good',
  },
};

export default packingMockData;
